import { useHistory } from 'react-router-dom'
import BaseButton from '../../components/BasicComponent/BaseButton'
import FixedBottom from '../../components/BasicComponent/FixedBottom'
import LayoutPartner from '../../components/FeaturesComponent/layoutPartner'
import { PATH } from '../../constants/router'
import imgIntroduce from '../../assets/images/automatedTrafficFineNotificationIntroduce.png'
import {
  IconAutomatedTrafficFineNotificationIntroduce1,
  IconAutomatedTrafficFineNotificationIntroduce2,
  IconAutomatedTrafficFineNotificationIntroduce3,
  IconAutomatedTrafficFineNotificationIntroduce4,
  IconAutomatedTrafficFineNotificationIntroduce5,
  IconAutomatedTrafficFineNotificationIntroduce6
} from '../../assets/icons'
import IconAutomatedTrafficFineNotificationIntroduce7 from '../../assets/icons/AutomatedTrafficFineNotificationIntroduce7.png'
import IconAutomatedTrafficFineNotificationIntroduce8 from '../../assets/icons/AutomatedTrafficFineNotificationIntroduce8.png'
import IconAutomatedTrafficFineNotificationIntroduce9 from '../../assets/icons/AutomatedTrafficFineNotificationIntroduce9.png'
import IconAutomatedTrafficFineNotificationIntroduce10 from '../../assets/icons/AutomatedTrafficFineNotificationIntroduce10.png'
import IconAutomatedTrafficFineNotificationIntroduce11 from '../../assets/icons/AutomatedTrafficFineNotificationIntroduce11.png'
import IconAutomatedTrafficFineNotificationIntroduce12 from '../../assets/icons/AutomatedTrafficFineNotificationIntroduce12.png'
import IconAutomatedTrafficFineNotificationIntroduce13 from '../../assets/icons/AutomatedTrafficFineNotificationIntroduce13.png'
import './index.scss'

export default function AutomatedTrafficFineNotificationIntroduce() {
  const history = useHistory()

  const handleNextStep = () => {
    history.push(PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SERVICES)
  }

  const listDescription = [
    {
      icon: <img className="des_icon" src={IconAutomatedTrafficFineNotificationIntroduce10} alt="" />,
      text: 'Thông báo khi có vi phạm'
    },
    {
      icon: <img className="des_icon" src={IconAutomatedTrafficFineNotificationIntroduce11} alt="" />,
      text: 'Thông báo khi có vi phạm mới'
    },
    {
      icon: <IconAutomatedTrafficFineNotificationIntroduce1 className="des_icon" />,
      text: 'Thông báo phạt nguội'
    },
    {
      icon: <IconAutomatedTrafficFineNotificationIntroduce2 className="des_icon" />,
      text: 'Thông báo hạn đăng kiểm'
    },
    {
      icon: <IconAutomatedTrafficFineNotificationIntroduce4 className="des_icon" />,
      text: 'Ưu đãi 30% khi mua BH TNDS'
    },
    {
      icon: <img className="des_icon" src={IconAutomatedTrafficFineNotificationIntroduce12} alt="" />,
      text: 'Trợ lý tư vấn bảo hiểm'
    },
    {
      icon: <img className="des_icon" src={IconAutomatedTrafficFineNotificationIntroduce13} alt="" />,
      text: 'Trợ lý hỗ trợ thủ tục bảo hiểm'
    },
    {
      icon: <img className="des_icon" src={IconAutomatedTrafficFineNotificationIntroduce8} alt="" />,
      text: 'Hỗ trợ gói tín dụng chi phí giao thông'
    },
    {
      icon: <IconAutomatedTrafficFineNotificationIntroduce5 className="des_icon" />,
      text: 'Hỗ trợ tặng thẻ tín dụng ưu đãi'
    },
    {
      icon: <img className="des_icon" src={IconAutomatedTrafficFineNotificationIntroduce9} alt="" />,
      text: 'Hỗ trợ ưu đãi khi mua gói cứu hộ ô tô / xe máy'
    }
  ]
  return (
    <LayoutPartner blendHeaderWithBody={false}>
      <div className="AutomatedTrafficFineNotificationIntroduce">
        <div className="AutomatedTrafficFineNotificationIntroduce_img">
          <img src={imgIntroduce} alt="" />
        </div>
        <div className="AutomatedTrafficFineNotificationIntroduce_title">Đăng ký nhận thông báo tự động</div>
        <div className="AutomatedTrafficFineNotificationIntroduce_des">
          {listDescription.map((item, index) => (
            <div key={index} className="AutomatedTrafficFineNotificationIntroduce_des_item">
              {item.icon}
              <div className="des_text">{item.text}</div>
            </div>
          ))}
        </div>
      </div>
      <FixedBottom elementPaddingBottom={'LayoutPartner'}>
        <BaseButton onClick={handleNextStep}>Tiếp theo</BaseButton>
      </FixedBottom>
    </LayoutPartner>
  )
}
